module.exports = __webpack_public_path__ + "img/brand_7.9b19f731.png";